import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { Gruppe } from '../../../../../projects/kiene-core/src/lib/components/gruppen/classes/gruppe';
import { GruppeEinstallenDialogInsert } from './gruppe-einstallen-dialog-insert';
import { EinstallenMeldenDialogComponent } from '../../../../../projects/kiene-core/src/lib/components/gruppen/gruppe-einstallen/einstallen-melden-dialog/einstallen-melden-dialog.component';
import { EinstallenMeldenDialogResult } from '../../../../../projects/kiene-core/src/lib/components/gruppen/classes/einstallen-melden';
import {
    ConfirmDialogInput,
    ConfirmDialogResult,
} from '../../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog';
import { ConfirmDialogComponent } from '../../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog.component';
import { EinstallenSubmitFlowService } from '../../../../../projects/kiene-core/src/lib/components/gruppen/gruppe-einstallen/einstallen-submit-flow.service';
import { EinstallenService } from '../../../../../projects/kiene-core/src/lib/components/gruppen/gruppe-einstallen/einstallen.service';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-gruppe-einstallen-dialog',
    templateUrl: './gruppe-einstallen-dialog.component.html',
    styleUrls: ['./gruppe-einstallen-dialog.component.scss'],
})
export class GruppeEinstallenDialogComponent implements OnInit, OnDestroy {
    gruppe: Gruppe;
    showPassReiter: boolean;
    canEditGewicht = false;

    constructor(
        public dialogRef: MatDialogRef<GruppeEinstallenDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: GruppeEinstallenDialogInsert,
        private dialog: MatDialog,
        private readonly einstallenSubmitFlow: EinstallenSubmitFlowService,
        private readonly einstallenService: EinstallenService,
        private readonly messageService: MessageService,
    ) {
        this.gruppe = this.data.gruppe;
        this.showPassReiter = this.data.showPassReiter;
    }

    ngOnInit(): void {
        this.einstallenService.clearLastScanErgebnisse();
        this.einstallenService.clearPendingGewichte();
        this.einstallenService.clearCurrentEinstalldatum();
        this.einstallenService.clearCurrentEinstallTierlisteId();
        this.canEditGewicht = this.einstallenSubmitFlow.currentUserCanEditGewicht();
        document.body.classList.add('einstallen-dialog-open');
    }

    ngOnDestroy(): void {
        document.body.classList.remove('einstallen-dialog-open');
    }

    melden() {
        const gruppeId = this.gruppe?.gruppe_id;
        if (!gruppeId) {
            return;
        }

        this.einstallenSubmitFlow
            .ensureFullTierlisteForReview(gruppeId, this.einstallenService.getCurrentEinstallTierlisteId())
            .subscribe({
                next: () => this.continueMelden(),
                error: err => this.messageService.errorMessage('Fehler beim Laden!', err),
            });
    }

    private continueMelden(): void {
        const letzteScans = this.einstallenSubmitFlow.getLastSuccessfulScans();
        const missingScans = this.einstallenSubmitFlow.getMissingGewichtScans();

        if (!this.canEditGewicht || missingScans.length <= 0) {
            this.openEinstallenMeldenDialog();
            return;
        }

        const askInput = new ConfirmDialogInput();
        askInput.headline = 'Gewichte fehlen';
        askInput.text =
            `Für ${missingScans.length} von ${letzteScans.length} erfolgreichen Scans fehlt das Einstallgewicht. Möchten Sie diese Gewichte jetzt erfassen?`;
        askInput.okButton = 'Ja';
        askInput.cancelButton = 'Nein';

        this.dialog
            .open(ConfirmDialogComponent, { data: askInput })
            .afterClosed()
            .subscribe((resp: ConfirmDialogResult) => {
                if (resp?.confirmed) {
                    this.einstallenSubmitFlow
                        .openGewichteDialog(this.gruppe?.gruppe_id, letzteScans)
                        .subscribe((saved: boolean) => {
                            if (saved) {
                                this.openEinstallenMeldenDialog();
                            }
                        });
                } else {
                    this.openEinstallenMeldenDialog();
                }
            });
    }

    private openEinstallenMeldenDialog(submitLockMs?: number): void {
        this.dialog
            .open(EinstallenMeldenDialogComponent, {
                width: '100%',
                maxWidth: '400px',
                data: this.einstallenSubmitFlow.createMeldenDialogInput(this.gruppe?.gruppe_id, this.gruppe?.gs_id, submitLockMs),
            })
            .afterClosed()
            .subscribe({
                next: (result: EinstallenMeldenDialogResult) => {
                    if (result?.ok) {
                        this.dialogRef.close();
                    }
                },
            });
    }

    private openGewichteDialog(): void {
        this.einstallenSubmitFlow
            .openGewichteDialog(this.gruppe?.gruppe_id)
            .subscribe((saved: boolean) => {
                if (saved) {
                    setTimeout(() => this.openEinstallenMeldenDialog(1500), 200);
                }
            });
    }
}
